import { action } from 'typesafe-actions';
import { IGetJobTitleOptions, IGetOrgJobTitleOptions, IJobTitlesResponse, IOrgJobTitlesResponse } from 'types';
import { JobTitles } from './types';

// Get Site Job Titles
export const getJobTitlesRequest = (options: IGetJobTitleOptions) => action(JobTitles.GET_JOB_TITLES_REQUEST, options);
export const getJobTitlesSuccess = (response: IJobTitlesResponse) => action(JobTitles.GET_JOB_TITLES_SUCCESS, { ...response });
export const getJobTitlesError = (error: any) => action(JobTitles.GET_JOB_TITLES_FAIL, error);

// Get Org Job Titles
export const getOrgJobTitlesRequest = (options: IGetOrgJobTitleOptions) => action(JobTitles.GET_ORG_JOB_TITLES_REQUEST, options);
export const getOrgJobTitlesSuccess = (response: IOrgJobTitlesResponse) => action(JobTitles.GET_ORG_JOB_TITLES_SUCCESS, { ...response });
export const getOrgJobTitlesError = (error: any) => action(JobTitles.GET_ORG_JOB_TITLES_FAIL, error);

export const resetJobTitles = () => action(JobTitles.RESET_JOB_TITLES);
